import axios from 'axios'
import store from './store'
import router from './router'
import { Message } from 'element-ui'

// 创建axios实例
var Axios = axios.create({
  timeout: 10000, // 10s超时
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
})

// 请求拦截
Axios.interceptors.request.use(
  // 请求发送前
  config => {
    // 如果TOKEN存在，每个http header都加上TOKEN
    if (store.state.TOKEN) {
      config.headers.Authorization = `token ${store.state.TOKEN}`
    }
    return config
  }
)

// 添加响应拦截器
Axios.interceptors.response.use(
  response => {
    if (response.data.retcode === 1) {
      Message({
        message: response.data.msg,
        type: 'success'
      })
    } else if (router.currentRoute.name !== 'home' && response.data.retcode === -1) {
      Message({
        message: response.data.msg,
        type: 'error'
      })
    }

    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.commit('LOGOUT')
          Message({
            message: '登入超时，请重新登入',
            type: 'error'
          })
          break
        default:
          if(router.currentRoute.name !== 'home') {
            Message({
              message: error.response.data,
              type: 'error'
            })
          }
      }
    }
    return Promise.reject(error.response)
  }
)

export default Axios
